import {
  faCalendarCheck,
  faEnvelopeOpenText,
  faFilter,
  faMicrophone,
  faReply,
  faRobot,
  faStar,
} from '@fortawesome/free-solid-svg-icons';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface AiServiceDictionaryItem {
  title: string;
  description: string;
  icon: IconDefinition;
}

export const AI_SERVICE_TOKEN_NOTE =
  'Расходует токены ИИ, которые оплачиваются с баланса филиала.';

export const CALL_TRANSCRIPTION_SERVICE_KEY = 'call-transcription';
export const CALL_GRADING_SERVICE_KEY = 'call-grading';
export const CLIENT_RECORD_SERVICE_KEY = 'client-record';
export const ROBOT_REPLY_SERVICE_KEY = 'robot-reply';
export const LEADS_BY_DESCRIPTION_SERVICE_KEY = 'leads-by-description';

export const AI_SERVICES_DICTIONARY: Record<string, AiServiceDictionaryItem> = {
  'email-parsing': {
    title: 'Парсинг почты',
    description:
      'Автоматически распознаёт входящие письма и преобразует их в заявки с заполнением необходимых полей.',
    icon: faEnvelopeOpenText,
  },
  'auto-reply': {
    title: 'Авто-ответ клиенту',
    description: 'ИИ готовит ответ клиенту на основе контекста переписки.',
    icon: faReply,
  },
  [CALL_TRANSCRIPTION_SERVICE_KEY]: {
    title: 'Транскрипция звонка в текст',
    description: 'Преобразует аудиозапись разговора в текстовый формат.',
    icon: faMicrophone,
  },
  [CALL_GRADING_SERVICE_KEY]: {
    title: 'Оценка записи разговора',
    description:
      'ИИ анализирует звонок и выставляет оценку качества общения оператора с клиентом.',
    icon: faStar,
  },
  [CLIENT_RECORD_SERVICE_KEY]: {
    title: 'Запись клиента',
    description:
      'Автоматически распознаёт переписку с клиентом и предлагает создать запись на услуги.',
    icon: faCalendarCheck,
  },
  [ROBOT_REPLY_SERVICE_KEY]: {
    title: 'Авто-ответ клиенту роботом',
    description:
      'ИИ-робот готовит ответ клиенту на основе контекста переписки, побуждая его к покупке товаров и услуг.',
    icon: faRobot,
  },
  [LEADS_BY_DESCRIPTION_SERVICE_KEY]: {
    title: 'Робот поиска лидов по описанию',
    description:
      'ИИ-робот периодически ищет лиды по вашему описанию и перемещает их в указанную воронку продаж.',
    icon: faFilter,
  },
};
